/* eslint-disable import/prefer-default-export */
import { useMutation } from '@tanstack/react-query';
import { useApiClient } from 'utils/apiClient';

export const useCalendarRedirect = () => {
  const apiClient = useApiClient();
  return useMutation({
    mutationFn: apiClient.Common.getCalendarRedirect,
    retry: false,
  });
};
